export default "/images/vendor/flag-icon-css/flags/1x1/ad.svg?aa31ee0af98d08407676d980e22a5012";